import * as ko from "knockout";
import type {TBaseOrObservableType} from "../../../index";
import {IComboboxV2Options} from "../../combobox/v2";
import mappingHtml from "./mapping.html?raw";

export let template: string = mappingHtml;

interface IClaimSuggestion {
    name: string
    label: string
}

interface IIdentifierField {
    id: string
    labelKey: string
}

interface IMappingParams {
    readOnly: boolean
    source?: string
    fieldKey?: string
    claimComboboxOptions?: IComboboxV2Options<IClaimSuggestion>
    primaryField?: KnockoutObservable<string | undefined>
    identifierFields?: IIdentifierField[]
    fieldPlaceholder?: TBaseOrObservableType<string>
}

export class viewModel {
    readonly readOnly: boolean;
    readonly source: string;
    readonly fieldKey: string;
    readonly claimComboboxOptions: IComboboxV2Options<IClaimSuggestion> | undefined;
    readonly primaryField: KnockoutObservable<string | undefined>;
    readonly identifierFields: IIdentifierField[];
    readonly fieldPlaceholder: TBaseOrObservableType<string>;

    constructor(params: IMappingParams) {
        this.readOnly = params.readOnly;
        this.source = params.source ?? "";
        this.fieldKey = params.fieldKey ?? "";
        this.claimComboboxOptions = params.claimComboboxOptions;
        this.primaryField = params.primaryField ?? ko.observable<string | undefined>(undefined);
        this.identifierFields = params.identifierFields ?? [];
        this.fieldPlaceholder = params.fieldPlaceholder ?? "";
    }
}
